var globalFunctions = require('./globalFunctions.js');

module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title-long">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>1&-2.5</li> '+
                            '<li>X&-2.5</li> '+
                            '<li>2&-2.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>1&+2.5</li> '+
                            '<li>X&+2.5</li> '+
                            '<li>2&+2.5</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title-long">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                         '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="1&-2.5" data-betCode="124" class="bet-choose" data-odd="'+quotes.Under25_1+'">'+globalFunctions.checkQuotes(quotes.Under25_1)+'</li> '+
                                '<li data-betType="X&-2.5" data-betCode="24" class="bet-choose" data-odd="'+quotes.Under25_X+'">'+globalFunctions.checkQuotes(quotes.Under25_X)+'</li> '+
                                '<li data-betType="2&-2.5" data-betCode="224" class="bet-choose" data-odd="'+quotes.Under25_2+'">'+globalFunctions.checkQuotes(quotes.Under25_2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="1&+2.5" data-betCode="126" class="bet-choose" data-odd="'+quotes.Over25_1+'">'+globalFunctions.checkQuotes(quotes.Over25_1)+'</li> '+
                                '<li data-betType="X&+2.5" data-betCode="26" class="bet-choose" data-odd="'+quotes.Over25_X+'">'+globalFunctions.checkQuotes(quotes.Over25_X)+'</li> '+
                                '<li data-betType="2&+2.5" data-betCode="226" class="bet-choose" data-odd="'+quotes.Over25_2+'">'+globalFunctions.checkQuotes(quotes.Over25_2)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/final_score_and_under_over_2.js
// module id = 2017
// module chunks = 4